import { useLeafletContext } from '@react-leaflet/core'
import L from 'leaflet'
import { useContext, useState } from 'react'
import { useEffect } from 'react'
import { isMobile } from 'react-device-detect'
import "./Legend.css"
import { ChoosenDataSet } from './partials/context/ChoosenDataSet'
import { NewAddDomain } from './partials/context/NewAddDomain'
import { SelectedDataSet } from './partials/context/SelectedDataset'

function CustomLegend(props) {
    // console.log(props)
    const [pallete, setPallete] = useState([]);
    const [min, setMin] = useState();
    const [max, setMax] = useState();
    const [datasetName, setDatasetName] = useState();
    const { getSelectedDatasetName } = useContext(SelectedDataSet);
    // console.log(props.pallete);
    // if (props.pallete) {
    //     Object.entries(props.pallete).map((el) => {
    //         console.log(el[0])
    //     })
    // }
    console.log(props);
    console.log(pallete)
    useEffect(() => {
        if (props.pallete) {
            // console.log(props.pallete)
            setPallete(Object.entries(props.pallete).map((el) => {
                console.log(el);
                return el;
            }))
        }
        if (props.dataset) {
            const arr = [];
            for (let i = 0; i < props.dataset.palette.length; i++) {
                arr.push([i, props.dataset.palette[i]]);
            }
            setPallete(arr)
        }
        if (props.min && props.min!="none") {
            // console.log(props.min);
            // setMin(props.min.toExponential(1));
            if (props.min.toString().includes("0.000") || +props.min>999) {
                setMin(props.min.toExponential(3).replace("e","E"));
            }
            else {
                if (props.min.toString().includes(".") == false) {
                    setMin(props.min);
                }
                else if (props.min.toString().includes(".") == true) {
                    // console.log(props.min)
                    setMin(props.min.toFixed(3))
                }
                
            }
        }
        if (props.min == 0) {
            setMin(0)
        }
        if (props.max && props.max!="none") {
            if (props.max.toString().includes("0.000") || props.max>999) {
                setMax(props.max.toExponential(3).replace("e","E"));
            }
            else {
                if (props.max.toString().includes(".") == false) {
                    setMax(props.max);
                }
                else if (props.max.toString().includes(".") == true) {
                    setMax(props.max.toFixed(3))
                }
            }
            // setMax(props.max.toExponential(1));
        }
        if (props.max == 0) {
            setMax(0)
        }
        if (props.datasetName) {
            setDatasetName(props.datasetName)
            getSelectedDatasetName(props.datasetName);
        }
    }, [props])
    // console.log(min, max);
    // console.log(pallete);
    // console.log(props.min);
    // if (props.min != null) {
    //     if (props.min.toString().length > 5) {
    //         console.log(props.min.toExponential(2))
    //     }
    //     else {
    //         console.log(props.min);
    //     }
    // }
    // let datasetName;
    // if (newAddDataSet != undefined) {
    //     datasetName=newAddDataSet[selectedIdx[0]].name
    // }
    // else if(choosenData && selectedIdx) {
    //     datasetName=choosenData[selectedIdx[0]].name
    // }
    // console.log(datasetName);
    return (<div id={`${datasetName=="Land Surface Temperature" && isMobile && "land"}`} className={`${!isMobile?"info legend":"info-mob legend-mob"}`}>
        {/* <div className={`${isMobile?'min-max':"min-max-web"}`}>
            
            
        </div> */}
        <div id={`${(datasetName=="Power Plant Locations" || datasetName=="Palm Oil Plantation Types") &&!isMobile?"power":(datasetName=="Power Plant Locations" || datasetName=="Palm Oil Plantation Types")&&isMobile&&"power-mob"}`} className={`${!isMobile?'legendbar':"legendbar-mob"}`}>
            <span id={`${datasetName=="Palm Oil Plantation Types" && "palm"}`}  className='range'>{!isMobile?  max && max:min&&min}</span>
            
            {pallete!=undefined  && props.isLegendDiscrete === true ? pallete.reverse().map((element) => {
            // console.log(element[0])
                return (<div><i style={{ background: props.hexAppendString + element[1].trim() }}></i>{element[0]}<br /></div>)
            }) : ""}

            {!isMobile && pallete!=undefined && props.isLegendDiscrete === false ? pallete.reverse().map((element, index) =>
                (<div><i2 style={{ background: props.hexAppendString + element[1].trim() }}></i2><br></br></div>)
            ) : ""}
            {isMobile && pallete!=undefined && props.isLegendDiscrete === false ? pallete.map((element, index) =>
                (<i2 style={{ background: props.hexAppendString + element[1].trim() }}></i2>)
            ) : ""}
            <span id={`${datasetName=="Palm Oil Plantation Types" && "palm"}`} className='range'>{!isMobile?  min && min:max&&max}</span>
        </div>
        
    </div>)
}

export default CustomLegend